export default "__VITE_ASSET__sUJMgO0Y__"